import React, { useEffect } from 'react';
import {
  Form,
  FormInstance,
  SelectBooleanInput,
  NumberInput
} from 'blueprint-form';
import { Row, Col } from '../../../../grid';
import { CardBlock } from '../../../organisms/card';

interface EpxHeartSettingsData {
  alerts?: boolean;
  afterHourInfo?: boolean;
  weightGainDaily?: number;
  weightGainWeekly?: number;
  bp?: {
    upper: {
      min: number;
      max: number;
    };
    lower: {
      min: number;
      max: number;
    };
  };
}

const DefaultSettings: EpxHeartSettingsData = {
  alerts: true,
  afterHourInfo: false,
  weightGainDaily: 3,
  weightGainWeekly: 5,
  bp: {
    upper: {
      min: 90,
      max: 180
    },
    lower: {
      min: 60,
      max: 110
    }
  }
};

interface EpxHeartSettingsProps {
  setForm?: (form: FormInstance<EpxHeartSettingsData>) => void;
  onSubmit?: (data: EpxHeartSettingsData) => void;
  disabled?: boolean;
}

const EpxHeartSettings = ({
  setForm,
  onSubmit: _onSubmit,
  disabled
}: EpxHeartSettingsProps): JSX.Element => {
  const form = new FormInstance<EpxHeartSettingsData>(DefaultSettings);
  useEffect(() => {
    if (setForm) {
      setForm(form);
    }
  }, []);
  const onChange = (data: EpxHeartSettingsData): void => {
    form.setData(data);
  };
  const onSubmit = (data: EpxHeartSettingsData): void => {
    _onSubmit(data);
  };
  return (
    <CardBlock bare>
      <Form form={form} onChange={onChange} onSubmit={onSubmit}>
        <CardBlock>
          <Row>
            <Col sm={12}>
              <SelectBooleanInput
                label="Enable Alerts for Patient"
                name="alerts"
                fill
                disabled={disabled}
              />
            </Col>
            <Col sm={12}>
              <SelectBooleanInput
                label="Inform Business Hour"
                name="afterHourInfo"
                fill
                disabled={disabled}
              />
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              <NumberInput
                label="Weight Gain (lbs) Threshold (Daily)"
                name="thresholds.weightGainDaily"
                fill
                disabled={disabled}
              />
            </Col>
            <Col sm={12}>
              <NumberInput
                label="Weight Gain (lbs) Threshold (Weekly)"
                name="thresholds.weightGainWeekly"
                fill
                disabled={disabled}
              />
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              <NumberInput
                label="Red - Systolic Min"
                name="thresholds.bp.upper.min"
                required
                fill
                disabled={disabled}
              />
            </Col>
            <Col sm={12}>
              <NumberInput
                label="Red - Systolic Max"
                name="thresholds.bp.upper.max"
                required
                fill
                disabled={disabled}
              />
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              <NumberInput
                label="Red - Diastolic Min"
                name="thresholds.bp.lower.min"
                required
                fill
                disabled={disabled}
              />
            </Col>
            <Col sm={12}>
              <NumberInput
                label="Red - Diastolic Max"
                name="thresholds.bp.lower.max"
                required
                fill
                disabled={disabled}
              />
            </Col>
          </Row>
        </CardBlock>
      </Form>
    </CardBlock>
  );
};

export default EpxHeartSettings;
